module.exports = __webpack_public_path__ + "img/newYw.75a0169f.png";